import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Textarea from '@/components/forms/Textarea';

import { nameValidationRegex } from '@/constants/regex';
import { z } from 'zod';
import { useSubDomainMutation } from '../hooks/useSubDomainMutation';

const formSchema = z.object({
  subDomainName: z
    .string()
    .min(1, { message: 'common.form.validation.required' })
    .regex(nameValidationRegex, 'common.form.validation.nameOnly'),
  description: z
    .string()
    .refine((val) => val == null || val === '' || nameValidationRegex.test(val), {
      message: 'common.form.validation.nameOnly',
    })
    .optional(),
});

const ManageClubSubdomainForm = ({
  defaultValues,
  clubId,
}: {
  defaultValues: { subDomainName: string; description: string };
  clubId: string;
}) => {
  const form = useForm({
    schema: formSchema,
    mode: 'onBlur',
    defaultValues: defaultValues,
  });

  const { mutateAsync } = useSubDomainMutation();

  return (
    <Form form={form} onSubmit={(data) => mutateAsync({ clubId, ...data })}>
      <div className="gap-2.5 flex flex-col">
        <div>
          <div className="text-control font-bold color-primary flex items-center mb-2"></div>
          <Input
            label="common.form.label.subdomainName"
            {...form.register('subDomainName')}
            placeholder="サブドメイン名を入力してください"
            maxLength={50}
          />
        </div>
        <div>
          <Textarea
            label="common.form.label.description"
            {...form.register('description')}
            placeholder="タイトルを入力してください"
            className="resize-none"
            maxLength={200}
          />
        </div>
      </div>
    </Form>
  );
};
export default ManageClubSubdomainForm;
